const PLATFORM_NAMES: Record<string, string> = {
  google: "Google",
  facebook: "Facebook",
  yelp: "Yelp",
  thumbtack: "Thumbtack",
  nextdoor: "Nextdoor",
  bbb: "the BBB",
  angi: "Angi",
  homeadvisor: "HomeAdvisor",
};

// Not Intl.ListFormat: apps/web and apps/booking compile this file against a lib without it.
function joinWithAnd(names: string[]): string {
  if (names.length <= 2) return names.join(" and ");
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
}

/**
 * "Real customer reviews from Google, Facebook, and Yelp", in the order given, or
 * null when no platform can be named — `other` has no name to give.
 */
export function describeReviewSources(sources: readonly string[] | undefined): string | null {
  const names = [...new Set(sources ?? [])].flatMap((source) => PLATFORM_NAMES[source] ?? []);
  return names.length > 0 ? `Real customer reviews from ${joinWithAnd(names)}` : null;
}
